import { render, staticRenderFns } from "./individual_list.vue?vue&type=template&id=206ed9ee&scoped=true"
import script from "./individual_list.vue?vue&type=script&lang=js"
export * from "./individual_list.vue?vue&type=script&lang=js"
import style0 from "./individual_list.vue?vue&type=style&index=0&id=206ed9ee&prod&scoped=true&lang=less"
import style1 from "./individual_list.vue?vue&type=style&index=1&id=206ed9ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ed9ee",
  null
  
)

export default component.exports